Application.Floaters = {
    ui: {
        container: '.floater',
        close: '.floater__close'
    },
    ready: function () {

        var self = this;

        $(document).on('click', this.ui.close, function(event){
            event.preventDefault();
            self.close($(this).closest(self.ui.container));
        });

    },
    close: function($el){
        $el.removeClass('floater--active');
    }
};